import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState({
		'id': "",
	})
	const [providerTypes, setProviderTypes] = useState([])

	async function getSmsProvider() {
		var filterUrl = `/chain/sms-provider`

		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data);
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (data.id) {
			response = await PUT('/chain/sms-provider', data, { loader: true, notification: true })
		} else {
			response = await POST('/chain/sms-provider', data, { loader: true, notification: true })
			if (httpOk(response)) getSmsProvider()
		}

		if (httpOk(response)) { }
	}

	function handleChangeIntegrationKey(e) {
		var dataCopy = { ...data }
		dataCopy.config[e.target.name] = e.target.value

		setData(dataCopy)
	}

	// Выбранный в селекте провайдер целиком — из него берётся справка под полем
	function selectedProvider() {
		return providerTypes.find(option => option.id === data.integration_provider_id)
	}

	async function getSmsProviderTypes() {
		const response = await GET('/helper/sms-providers')
		if (httpOk(response)) setProviderTypes(response.data)
	}

	useEffect(() => {
		getSmsProvider()
		getSmsProviderTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('sms_provider')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4">
							<div className="form-group">
								<label>{t('type')}</label>
								<Select
									options={providerTypes}
									value={providerTypes.find(option => option.id === data.integration_provider_id) || ''}
									onChange={(option) => setData({
										...data,
										'integration_provider_id': option.id,
										'schema': option.schema,
										'config': option.config,
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							{/* Что за провайдер и что нужно для подключения: без этого выбор
								делается вслепую по одному названию. Цену показываем только у
								своего — у чужих клиент платит оператору напрямую, и она нам
								неизвестна; и берём её живой, а не текстом из справочника. */}
							{selectedProvider() &&
								<div className="alert alert-light border" style={{ 'fontSize': '.85rem' }}>
									<div>{selectedProvider().description}</div>

									{selectedProvider().billing?.price > 0 &&
										<div className="mt-2 fw-600">
											{selectedProvider().billing.price} {t('currency_soum')} {t('per_sms')}
											<span className="text-muted fw-normal">
												{' · '}{t('balance')}: {Number(selectedProvider().billing.balance || 0).toLocaleString()}
												{selectedProvider().billing.messages_left !== null &&
													<> {' ≈ '}{selectedProvider().billing.messages_left} SMS</>
												}
											</span>
										</div>
									}

									<div className="mt-2 d-flex gap-3">
										{selectedProvider().website &&
											<a href={selectedProvider().website} target="_blank" rel="noreferrer">
												<i className="uil-external-link-alt" /> {selectedProvider().website.replace(/^https?:\/\//, '')}
											</a>
										}
										{selectedProvider().doc_url &&
											<a href={selectedProvider().doc_url} target="_blank" rel="noreferrer">
												<i className="uil-book-open" /> {t('documentation')}
											</a>
										}
									</div>
								</div>
							}

							{data?.schema?.fields?.length > 0 && (
								<>
									{data.schema.fields.map((field) => (
										<div className="form-group w-100" key={field.key}>

											<label>
												{field.label ?? field.key}
												{field.required && <span style={{ color: 'red' }}> *</span>}
											</label>

											<input
												type={field.type === 'password' ? 'password' : 'text'}
												className="form-control"
												name={field.key}
												autoComplete="off"
												value={data?.config?.[field.key] ?? ''}
												onChange={handleChangeIntegrationKey}
											/>
										</div>
									))}
								</>
							)}
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index